import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";
import { useProject } from "../project";

interface Input {
    name?: string;
    description?: string;
    ownerId?: string | null;
}

export function useUpdateWorkstreamMutation(workstreamId: string) {
    const { project } = useProject();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (input: Input) => {
            await apiClient.updateWorkstream({
                params: {
                    projectId: project.id,
                    workstreamId: workstreamId,
                },
                body: input,
            });
            await queryClient.refetchQueries({ queryKey: ["project", project.id] });
        },
    });
}
